import type { FaireProductEntity } from "@faire/playground-entity-db/entity_types/product";
import { getAllEntities } from "../get_entity";

export const products: FaireProductEntity[] = getAllEntities("product");

export const getProductsForGrid = (
  rows: number,
  columns: number = 6
): FaireProductEntity[] => {
  const totalNeeded = rows * columns;
  if (products.length === 0) {
    return [];
  }
  if (totalNeeded <= products.length) {
    return products.slice(0, totalNeeded);
  }

  const repeated: FaireProductEntity[] = [];
  for (let i = 0; i < totalNeeded; i += 1) {
    repeated.push(products[i % products.length]);
  }
  return repeated;
};
